import { ChevronDown, MapPin } from "lucide-react";

export const Hero = () => {
    return (
        <section id="inicio" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
            <div className="absolute inset-0">
                <img
                    src="/chales/scandinavian/1.jpg"
                    alt="Chalé na natureza em Ouro Preto"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/45" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pb-32 pt-48 w-full">
                <p className="animate-fade-up uppercase text-xs font-bold tracking-[0.3em] text-[#E9DCC8] mb-6 flex items-center gap-2">
                    <MapPin className="w-4 h-4" strokeWidth={1.5} />
                    Ouro Preto · Minas Gerais
                </p>
                <h1 className="animate-fade-up delay-100 text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter leading-none text-white drop-shadow-lg max-w-3xl">
                    Refúgio de luxo no coração da natureza
                </h1>
                <p className="animate-fade-up delay-200 mt-8 text-base md:text-lg text-white/90 max-w-xl leading-relaxed drop-shadow">
                    Chalés exclusivos com piscina privativa, sauna, banheira e vistas panorâmicas.
                    Viva momentos inesquecíveis a dois na Rarity Chalés.
                </p>
                <div className="animate-fade-up delay-300 mt-12 flex flex-wrap gap-4">
                    <a
                        href="#chales"
                        data-testid="hero-cta-chales"
                        className="bg-[#FDFBF7] text-[#1B4332] font-bold text-sm px-8 py-4 rounded-full hover:bg-white transition-colors duration-300"
                    >
                        Conheça os chalés
                    </a>
                    <a
                        href="#contato"
                        data-testid="hero-cta-contato"
                        className="border border-white/60 text-white font-bold text-sm px-8 py-4 rounded-full hover:bg-white/10 transition-colors duration-300"
                    >
                        Fale conosco
                    </a>
                </div>
            </div>

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/70 animate-bounce">
                <ChevronDown className="w-6 h-6" strokeWidth={1.5} />
            </div>
        </section>
    );
};
